// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__2zLgz","additionalInfo":"AgreementModal_additionalInfo__2lQzU"};